import React, { useState, useEffect, Fragment, useRef } from 'react';
import groupService from '../../../Group/services';
import service from '../service';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { PageHeader } from '../../../../Common';
import Joi from '@hapi/joi';
import { validateProperty } from "../../../Common";
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import "react-datepicker/dist/react-datepicker.css";
import { DeductionSummaryReportSchema } from "../DeductionSummaryReportSchema";
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import '../../../Common/Table/table.css';
import CreatePDF from './createPdf';
import ReactToPrint from "react-to-print";
import _, { flatMap } from 'lodash';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Card from '@material-ui/core/Card';
import { makeStyles } from '@material-ui/core/styles';
import { Container } from '@material-ui/core';

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    dialog1: {
        width: 850,
    }
});

const screenCode = 'DEDUCTIONSUMMARYREPORT';

export function DeductionSummaryReport(props) {
    const classes = useStyles();
    const componentRef = useRef();
    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [collectionPoint, setCollectionPoint] = useState([]);
    const [searchData, setsearchData] = useState({
        groupID: 0,
        operationEntityID: 0,
        collectionPointID: 0,
        searchDate: ""
    });
    const [errors, setErrors] = useState({});
    const schema = Joi.object(DeductionSummaryReportSchema).options({ allowUnknown: true });
    const [reportData, setReportData] = useState([]);
    const [columeNames, setColumeNames] = useState([]);
    const [factoryDeductionData, setFactoryDeductionData] = useState([]);
    const [fieldDeductionData, setFieldDeductionData] = useState([]);
    const [plukerDeductionData, setPlukerDeductionData] = useState([]);
    const [totalArray, setTotalArray] = useState([]);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupID: 0,
        operationEntityID: 0,
        collectionPointID: 0,
        searchDate: ""
    });

    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, [])

    useEffect(() => {
        trackPromise(
            getOperationEntities()
        )
    }, [searchData.groupID])

    useEffect(() => {
        trackPromise(
            getCollectionPointsForDropDown()
        )
    }, [searchData.operationEntityID])

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWDEDUCTIONSUMMARYREPORT');
        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();

        setsearchData({
            ...searchData,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        getGroupsForDropDown();
    }

    async function getGroupsForDropDown() {
        const groupsList = await groupService.getGroupsForDropdown();
        setGroups(groupsList);
    }

    async function getOperationEntities() {
        const operationEntityList = await service.getOperationEntitiesByGroupForDropDown(searchData.groupID);
        setOperationEntity(operationEntityList);
    }

    async function getCollectionPointsForDropDown() {
        const collectionPoint = await service.getCollectionPointsByOperationentityGroupID(searchData.operationEntityID, searchData.groupID);
        setCollectionPoint(collectionPoint);
    }

    function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, DeductionSummaryReportSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setsearchData({
            ...searchData,
            [e.target.name]: value
        });

        setErrors(error);
    }
    async function handleSearch(e) {
        const response = await service.GetDeductionSummaryData(searchData);

        const factoryDetails = response.factoryDetails
        const fieldDetails = response.fieldDetails
        const pluckerDetails = response.pluckerDetails

        let factoryResult = [];
        let fieldResult = [];
        let pluckerResult = [];

        let factoryDeductionDataList = [];
        let fieldDeductionDataList = [];
        let pluckerDeductionDataList = [];

        if (factoryDetails.length != 0) {
            const factoryDeductionUniqueData = [...new Set(factoryDetails.map(item => item.deductionTypeIDF))].map(name => {
                return factoryDetails.find(item => item.deductionTypeIDF === name);
            });
            setFactoryDeductionData(factoryDeductionUniqueData)

            factoryDeductionDataList = factoryDeductionUniqueData
            var copyOfFactoryDetails = _.cloneDeep(factoryDetails);
            var result = formatFactoryDetails(copyOfFactoryDetails);
            factoryResult = result;
        }
        if (fieldDetails.length != 0) {
            const fieldDeductionUniqueData = [...new Set(fieldDetails.map(item => item.deductionTypeID))].map(name => {
                return fieldDetails.find(item => item.deductionTypeID === name);
            });
            setFieldDeductionData(fieldDeductionUniqueData)

            fieldDeductionDataList = fieldDeductionUniqueData
            var copyOfFieldDetails = _.cloneDeep(fieldDetails);
            var result = formatFiledDetails(copyOfFieldDetails);
            fieldResult = result;
        }
        if (pluckerDetails.length != 0) {
            const pluckerDeductionUniqueData = [...new Set(pluckerDetails.map(item => item.deductionTypeIDP))].map(name => {
                return pluckerDetails.find(item => item.deductionTypeIDP === name);
            });
            setPlukerDeductionData(pluckerDeductionUniqueData)

            pluckerDeductionDataList = pluckerDeductionUniqueData
            var copyOfPluckerDetails = _.cloneDeep(pluckerDetails);
            var result = formatPluckerDetails(copyOfPluckerDetails);
            pluckerResult = result;
        }
        createColumNames(factoryDeductionDataList, fieldDeductionDataList, pluckerDeductionDataList);
        var joinedArray = _.merge(_.keyBy(pluckerResult, 'fieldID'), _.keyBy(fieldResult, 'fieldID'), _.keyBy(factoryResult, 'fieldID'));

        var joinedResult = [];
        var finalResult = [];

        Object.keys(joinedArray).forEach(x => joinedResult.push(joinedArray[x]));
        joinedResult.forEach(x => {
            finalResult.push(x);
        });
        finalResult.sort((a, b) => a.collectionPointName > b.collectionPointName ? 1 : -1);

        var copyOfFinalResult = _.cloneDeep(finalResult);
        setSelectedSearchData();
        calTotalRow(copyOfFinalResult);
        setReportData(finalResult)
    }

    function formatFactoryDetails(data) {
        var result = [];

        data.forEach(x => {
            var deductionTypeID = x.deductionTypeIDF;
            var duplicateDate = result.find(y => y.fieldID === x.fieldID);

            if (duplicateDate) {
                duplicateDate['Fac ' + deductionTypeID] = duplicateDate['Fac ' + deductionTypeID] == undefined ? 0 + x.deductionAmountF : duplicateDate['Fac ' + deductionTypeID] + x.deductionAmountF;
                duplicateDate.grossAmountF = duplicateDate.grossAmountF == undefined ? 0 + x.grossAmountF : duplicateDate.grossAmountF + x.grossAmountF;
                duplicateDate.netAmountF = duplicateDate.netAmountF == undefined ? 0 + x.netAmountF : duplicateDate.netAmountF + x.netAmountF;
                duplicateDate.noOfBagsF = duplicateDate.noOfBagsF == undefined ? 0 + x.noOfBagsF : duplicateDate.noOfBagsF + x.noOfBagsF;
                duplicateDate.collectionPointID = x.collectionPointID;
                duplicateDate.collectionPointName = x.collectionPointName;
                duplicateDate.fieldID = x.fieldID;
                duplicateDate.fieldName = x.fieldName;
            }
            else {
                result.push({
                    ['Fac ' + deductionTypeID]: x.deductionAmountF,
                    grossAmountF: x.grossAmountF,
                    netAmountF: x.netAmountF,
                    noOfBagsF: x.noOfBagsF,
                    collectionPointID: x.collectionPointID,
                    collectionPointName: x.collectionPointName,
                    fieldID: x.fieldID,
                    fieldName: x.fieldName
                });
            }
        });
        return result;
    }

    function formatFiledDetails(data) {
        var result = [];

        data.forEach(x => {
            var deductionTypeID = x.deductionTypeID;
            var duplicateDate = result.find(y => y.fieldID === x.fieldID);

            if (duplicateDate) {
                duplicateDate['Fil ' + deductionTypeID] = duplicateDate['Fil ' + deductionTypeID] == undefined ? 0 + x.deductionAmount : duplicateDate['Fil ' + deductionTypeID] + x.deductionAmount;
                duplicateDate.grossAmount = duplicateDate.grossAmount == undefined ? 0 + x.grossAmount : duplicateDate.grossAmount + x.grossAmount;
                duplicateDate.netAmount = duplicateDate.netAmount == undefined ? 0 + x.netAmount : duplicateDate.netAmount + x.netAmount;
                duplicateDate.noOfBags = duplicateDate.noOfBags == undefined ? 0 + x.noOfBags : duplicateDate.noOfBags + x.noOfBags;
                duplicateDate.collectionPointID = x.collectionPointID;
                duplicateDate.collectionPointName = x.collectionPointName;
                duplicateDate.fieldID = x.fieldID;
                duplicateDate.fieldName = x.fieldName;
            }
            else {
                result.push({
                    ['Fil ' + deductionTypeID]: x.deductionAmount,
                    grossAmount: x.grossAmount,
                    netAmount: x.netAmount,
                    noOfBags: x.noOfBags,
                    collectionPointID: x.collectionPointID,
                    collectionPointName: x.collectionPointName,
                    fieldID: x.fieldID,
                    fieldName: x.fieldName
                });
            }
        });
        return result;
    }

    function formatPluckerDetails(data) {
        var result = [];

        data.forEach(x => {
            var deductionTypeID = x.deductionTypeIDP;
            var duplicateDate = result.find(y => y.fieldID === x.fieldID);

            if (duplicateDate) {
                duplicateDate['Plu ' + deductionTypeID] = duplicateDate['Plu ' + deductionTypeID] == undefined ? 0 + x.deductionAmountP : duplicateDate['Plu ' + deductionTypeID] + x.deductionAmountP;
                duplicateDate.grossAmountP = duplicateDate.grossAmountP == undefined ? 0 + x.grossAmountP : duplicateDate.grossAmountP + x.grossAmountP;
                duplicateDate.netAmountP = duplicateDate.netAmountP == undefined ? 0 + x.netAmountP : duplicateDate.netAmountP + x.netAmountP;
                duplicateDate.noOfBagsP = duplicateDate.noOfBagsP == undefined ? 0 + x.noOfBagsP : duplicateDate.noOfBagsP + x.noOfBagsP;
                duplicateDate.collectionPointID = x.collectionPointID;
                duplicateDate.collectionPointName = x.collectionPointName;
                duplicateDate.fieldID = x.fieldID;
                duplicateDate.fieldName = x.fieldName;
            }
            else {
                result.push({
                    ['Plu ' + deductionTypeID]: x.deductionAmountP,
                    grossAmountP: x.grossAmountP,
                    netAmountP: x.netAmountP,
                    noOfBagsP: x.noOfBagsP,
                    collectionPointID: x.collectionPointID,
                    collectionPointName: x.collectionPointName,
                    fieldID: x.fieldID,
                    fieldName: x.fieldName
                });
            }
        });
        return result;
    }

    function calTotalRow(data) {
        var total = [];
        data.forEach(x => {
            for (var property in x) {
                if (property !== "collectionPointName" && property !== "collectionPointID" && property !== "fieldName" && property !== "fieldID") {
                    total.push({ name: property, value: x[property] });
                }
            }
        });

        const res = Array.from(total.reduce(
            (m, { name, value }) => m.set(name, parseFloat(m.get(name) || 0) + parseFloat(value)), new Map
        ), ([name, value]) => ({ name, value }));
        setTotalArray(res);
    }

    function createColumNames(factoryDeductionDataList, fieldDeductionDataList, pluckerDeductionDataList) {
        const columns = [];
        columns.push({ title: "No of Bags", key: "noOfBagsP" });
        columns.push({ title: "Gross (Kg)", key: "grossAmountP" });
        pluckerDeductionDataList.forEach(x => {
            columns.push({ title: x.deductionTypeNameP, key: 'Plu ' + x.deductionTypeIDP });
        });
        columns.push({ title: "Net (Kg))", key: "netAmountP" })
        columns.push({ title: "No of Bags", key: "noOfBags" })
        columns.push({ title: "Gross (Kg)", key: "grossAmount" })
        fieldDeductionDataList.forEach(x => {
            columns.push({ title: x.deductionTypeName, key: 'Fil ' + x.deductionTypeID });
        });
        columns.push({ title: "Net (Kg))", key: "netAmount" })
        columns.push({ title: "No of Bags", key: "noOfBagsF" })
        columns.push({ title: "Gross (Kg)", key: "grossAmountF" })
        factoryDeductionDataList.forEach(x => {
            columns.push({ title: x.deductionTypeNameF, key: 'Fac ' + x.deductionTypeIDF });
        });
        columns.push({ title: "Net (Kg))", key: "netAmountF" })

        setColumeNames(columns)
    }

    function setSelectedSearchData() {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchData.groupID],
            estate: operationEntity[searchData.operationEntityID],
            collectionID: collectionPoint[searchData.collectionPointID],
            searchDate: searchData.searchDate
        })
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="card">
                    <div className="card-body" id="startPoint">
                        <div className="row">
                            <PageHeader
                                title="Deduction Summary Report"
                            />
                        </div>
                        <form>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="groupID">Group *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="groupID"
                                        name="groupID"
                                        disabled={!permissionList.isGroupFilterEnabled}
                                        value={searchData.groupID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Group--</MenuItem>
                                        {generateDropDownMenu(groups)}
                                    </Select>
                                    {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="operationEntityID">Estate *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="operationEntityID"
                                        name="operationEntityID"
                                        disabled={!permissionList.isOperationEntityFilterEnabled}
                                        value={searchData.operationEntityID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Estate--</MenuItem>
                                        {generateDropDownMenu(operationEntity)}
                                    </Select>
                                    {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="collectionPointID">Division</InputLabel>
                                    <Select
                                        fullWidth
                                        id="collectionPointID"
                                        name="collectionPointID"
                                        value={searchData.collectionPointID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Division--</MenuItem>
                                        {generateDropDownMenu(collectionPoint)}
                                    </Select>
                                </div>
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="searchDate">Date *</InputLabel>
                                    <TextField
                                        fullWidth
                                        id="searchDate"
                                        name="searchDate"
                                        type="date"
                                        value={searchData.searchDate}
                                        onChange={(e) => handleChange(e)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />
                                </div>
                            </div>
                            {reportData.length != 0 ?
                                <Container>
                                    <Card style={{ justifycontent: 'center' }}>
                                        <Paper className={classes.paper}>
                                            <TableContainer>
                                                <Table aria-label="simple table">
                                                    <TableHead>
                                                        <TableRow style={{ border: "2px solid black" }}>
                                                            <TableCell align="center" rowSpan={2} style={{ border: "2px solid black", fontWeight: "bold" }}>Collection Point</TableCell>
                                                            <TableCell align="center" rowSpan={2} style={{ border: "2px solid black", fontWeight: "bold" }}>Field Name</TableCell>
                                                            <TableCell colSpan={3 + plukerDeductionData.length} align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>Plucker Collection</TableCell>
                                                            <TableCell colSpan={3 + fieldDeductionData.length} align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>Field Collection</TableCell>
                                                            <TableCell colSpan={3 + factoryDeductionData.length} align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>Factory Collection</TableCell>
                                                        </TableRow>
                                                        <TableRow style={{ border: "2px solid black" }}>
                                                            <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>No of Bags</TableCell>
                                                            <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>Gross (Kg)</TableCell>
                                                            {plukerDeductionData.map(item => {
                                                                return (<><TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{item.deductionTypeNameP}</TableCell> </>
                                                                )
                                                            })}
                                                            <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>Net (Kg)</TableCell>
                                                            <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>No of Bags</TableCell>
                                                            <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>Gross (Kg)</TableCell>
                                                            {fieldDeductionData.map(item => {
                                                                return (<><TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{item.deductionTypeName}</TableCell> </>
                                                                )
                                                            })}
                                                            <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>Net (Kg)</TableCell>
                                                            <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>No of Bags</TableCell>
                                                            <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>Gross (Kg)</TableCell>
                                                            {factoryDeductionData.map(item => {
                                                                return (<><TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{item.deductionTypeNameF}</TableCell> </>
                                                                )
                                                            })}
                                                            <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>Net (Kg)</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {reportData.map(item => {
                                                            return (
                                                                <>
                                                                    <TableRow style={{ border: "2px solid black" }}>
                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{item.collectionPointName}</TableCell>
                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{item.fieldName}</TableCell>
                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{(item.noOfBagsP == undefined || item.noOfBagsP == 0) ? '-' : item.noOfBagsP}</TableCell>
                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{(item.grossAmountP == undefined || item.grossAmountP == 0) ? '-' : parseFloat(item.grossAmountP).toFixed(2)}</TableCell>
                                                                        {plukerDeductionData.map(deduc => {
                                                                            var res = item['Plu ' + deduc.deductionTypeIDP]
                                                                            return (
                                                                                <>
                                                                                    <TableCell key={deduc} align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{(res == undefined || res == 0) ? '-' : parseFloat(res).toFixed(2)}</TableCell>
                                                                                </>)
                                                                        })}
                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{(item.netAmountP == undefined || item.netAmountP == 0) ? '-' : parseFloat(item.netAmountP).toFixed(2)}</TableCell>
                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{(item.noOfBags == undefined || item.noOfBags == 0) ? '-' : item.noOfBags}</TableCell>
                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{(item.grossAmount == undefined || item.grossAmount == 0) ? '-' : parseFloat(item.grossAmount).toFixed(2)}</TableCell>
                                                                        {fieldDeductionData.map(deduc => {
                                                                            var res = item['Fil ' + deduc.deductionTypeID]
                                                                            return (
                                                                                <>
                                                                                    <TableCell key={deduc} align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{(res == undefined || res == 0) ? '-' : parseFloat(res).toFixed(2)}</TableCell>
                                                                                </>)
                                                                        })}
                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{(item.netAmount == undefined || item.netAmount == 0) ? '-' : parseFloat(item.netAmount).toFixed(2)}</TableCell>
                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{(item.noOfBagsF == undefined || item.noOfBagsF == 0) ? '-' : item.noOfBagsF}</TableCell>
                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{(item.grossAmountF == undefined || item.grossAmountF == 0) ? '-' : parseFloat(item.grossAmountF).toFixed(2)}</TableCell>
                                                                        {factoryDeductionData.map(deduc => {
                                                                            var res = item['Fac ' + deduc.deductionTypeIDF]
                                                                            return (
                                                                                <>
                                                                                    <TableCell key={deduc} align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{(res == undefined || res == 0) ? '-' : parseFloat(res).toFixed(2)}</TableCell>
                                                                                </>)
                                                                        })}
                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{(item.netAmountF == undefined || item.netAmountF == 0) ? '-' : parseFloat(item.netAmountF).toFixed(2)}</TableCell>
                                                                    </TableRow>

                                                                </>
                                                            )
                                                        })}
                                                        <TableRow style={{ border: "2px solid black" }}>
                                                            <TableCell component="th" colSpan={2} align="center" style={{ border: "2px solid black", fontWeight: "bold" }}> Total</TableCell>
                                                            {columeNames.map((count) => {
                                                                const result = totalArray.find(x => x.name == count.key)

                                                                if (result == undefined) {
                                                                    return (
                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}> - </TableCell>
                                                                    );
                                                                }
                                                                else {
                                                                    if (result.name == 'noOfBagsP' || result.name == 'noOfBags' || result.name == 'noOfBagsF') {
                                                                        return (
                                                                            <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}> {parseInt(result.value)}</TableCell>
                                                                        );
                                                                    }
                                                                    else {
                                                                        return (
                                                                            <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}> {parseFloat(result.value).toFixed(2)}</TableCell>
                                                                        );
                                                                    }
                                                                }
                                                            })}
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Paper>
                                    </Card>
                                </Container>
                                : null}
                        </form>
                        {
                            (reportData.length == 0 || reportData == undefined || reportData == null || reportData == []) ?
                                null : <div className="pt-3">
                                    <ReactToPrint
                                        trigger={() => <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Create PDF"
                                        />}
                                        content={() => componentRef.current}
                                        documentTitle={'Deduction Summary Report'}
                                    />
                                    <div hidden={true}>
                                        <CreatePDF ref={componentRef} reportData={reportData} plukerDeductionData={plukerDeductionData}
                                            fieldDeductionData={fieldDeductionData} factoryDeductionData={factoryDeductionData} columeNames={columeNames}
                                            totalArray={totalArray} searchData={selectedSearchValues} />
                                    </div>
                                </div>
                        }
                    </div>
                </div>
            </div>
        </Fragment >
    );
}



